import React from 'react';

import { Optimize } from '@totem/components/ticketing/optimizeTypes';
import {
  calculateOptimizeROIPercent,
  calculateOptimizeROIValue,
} from '@totem/components/ticketing/ticket/specialCases/utilities';
import Currency from '@totem/components/ui_components/widgets/currency/Currency';

type Props = {
  optimize: Optimize;
};

const OptimizeRoiDisplay = ({ optimize }: Props) => {
  const roiValue = calculateOptimizeROIValue(optimize);
  const roiPercent = calculateOptimizeROIPercent(optimize);

  if (Number.isNaN(roiPercent)) {
    return <span />;
  }

  return (
    <span>
      <Currency amount={roiValue} /> ({roiPercent.toFixed(1)}%)
    </span>
  );
};

export default OptimizeRoiDisplay;
